import React, { useState } from 'react';
import { Form, FormControl, InputGroup } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';

const SearchBar = ({ loading, query: passedQuery, onSubmit, onSearchReset, placeholder }) => {
  const [query, setQuery] = useState(passedQuery || '');

  const onSearchSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(query);
  };

  const onReset = () => {
    setQuery('');
    onSubmit('');
    if (onSearchReset) onSearchReset();
  };

  const onChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (!value) {
      onSubmit('');
      if (onSearchReset) onSearchReset();
    }
  };
  return (
    <Form onSubmit={onSearchSubmit}>
      <Form.Group className="mb-3">
        <div style={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '50px',
          border: '1px solid #dee2e6',
          overflow: 'hidden',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          background: '#fff',
        }}>
          <input
            type="text"
            placeholder={placeholder || ''}
            value={query}
            onChange={onChange}
            style={{
              flex: 1,
              border: 'none',
              outline: 'none',
              boxShadow: 'none',
              paddingLeft: '1.2rem',
              paddingTop: '0.45rem',
              paddingBottom: '0.45rem',
              background: 'transparent',
              fontSize: '1rem',
            }}
          />
          {query && (
            <button
              type="button"
              onClick={onReset}
              data-testid="btn-searchbar-reset"
              title="Clear search"
              style={{
                border: 'none',
                background: 'transparent',
                color: '#999',
                cursor: 'pointer',
                padding: '0 0.5rem',
                fontSize: '0.9rem',
              }}
            >
              ✕
            </button>
          )}
          <Button
            type="submit"
            loading={loading}
            icon="search"
            variant="primary"
            data-testid="btn-searchbar-submit"
            size="md"
            disabled={!query}
            style={{
              borderRadius: '50px',
              margin: '3px',
              paddingLeft: '0.9rem',
              paddingRight: '0.9rem',
              border: 'none',
            }}
          />
        </div>
      </Form.Group>
    </Form>
  );
};

export default SearchBar;
